// Added by Sejune Oh on 2019-05-31
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface MessageDescriptor {
    id: string
    description?: string
    defaultMessage?: string
}
type MessageValue = string | number | boolean | Date | null | undefined

interface IntlFuncProps {
    (messageDescriptor: MessageDescriptor, values?: { [key: string]: MessageValue }, defaultMessage?: string): string
}

class Intl {
    getIntlText: IntlFuncProps = (msg, value, defaultMessage) => msg.id
    getIntlTextWithOption: IntlFuncProps = (msg, value, defaultMessage) => msg.id 
    getIntlTextLater: IntlFuncProps = (msg, value, defaultMessage) => msg.id 
    getRootIntlText: IntlFuncProps = (msg, value, defaultMessage) => msg.id

    // @ts-ignore
    _getIntlText(id: any, option?: any, defaultMessage?: string) {
        let props = [id]
        if (defaultMessage) props[0].defaultMessage = defaultMessage
        if (option) props.push(option)

        try {
            // @ts-ignore
            return this.formatMessage(...props)
        } catch (err) {
            // Logger.errLog(err)
            return defaultMessage || id.id
        }
    }

    _getRootIntlText(id: any, option?: any, defaultMessage?: string) {
        let props = [{ ...id, id: `${id.id}.${option.key}` }]
        if (defaultMessage) props[0].defaultMessage = defaultMessage
        if (option) props.push(option)

        try {
            // @ts-ignore
            return this.formatMessage(...props)
        } catch (err) {
            // Logger.errLog(err)
            return defaultMessage || id.id
        }
    }

    bindIntl(Intl: any) {
        this.getIntlText = this._getIntlText.bind(Intl)
        this.getIntlTextWithOption = this._getIntlText.bind(Intl)
        this.getIntlTextLater = this._getIntlText.bind(Intl)
        this.getRootIntlText = this._getRootIntlText.bind(Intl)
    }
}

const intl = new Intl()
export default intl
